import React from 'react';

const SignatureIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M12.917 12.9996C12.6623 14.4797 11.8619 15.8105 10.6739 16.7293C9.48593 17.6481 7.99666 18.0881 6.50009 17.9625C5.00352 17.837 3.60841 17.1549 2.59016 16.0509C1.57191 14.947 1.00452 13.5015 1 11.9996C0.998629 10.4942 1.56319 9.04333 2.58168 7.93478C3.60017 6.82623 4.99816 6.14105 6.49828 6.01517C7.9984 5.88929 9.49103 6.33191 10.68 7.25522C11.869 8.17853 12.6675 9.51506 12.917 10.9996H23V12.9996H21V16.9996H19V12.9996H17V16.9996H15V12.9996H12.917ZM7 15.9996C8.06087 15.9996 9.07828 15.5782 9.82843 14.8281C10.5786 14.0779 11 13.0605 11 11.9996C11 10.9388 10.5786 9.92134 9.82843 9.1712C9.07828 8.42105 8.06087 7.99963 7 7.99963C5.93914 7.99963 4.92172 8.42105 4.17158 9.1712C3.42143 9.92134 3 10.9388 3 11.9996C3 13.0605 3.42143 14.0779 4.17158 14.8281C4.92172 15.5782 5.93914 15.9996 7 15.9996Z"
      fill="currentColor"
    />
  </svg>
);

export default SignatureIcon;
